import MuiStack, { StackProps } from "@mui/material/Stack";

const Stack: React.FC<StackProps> = MuiStack;

export default Stack;
export type { StackProps };
